import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/blog/[slug]/sections/PageContent.tsx");
